import React from "react";
import { useCart } from "./CartContext";
import "./cart.scss";

export default function CartIcon() {
    const { totalQty, totalSum } = useCart();

    return (
        <button
            type="button"
            className="cartIcon"
            aria-label="Переглянути кошик"
            onClick={() => window.dispatchEvent(new CustomEvent("cart:open"))}
        >
            <svg className="cartIcon__svg" viewBox="0 0 24 24" aria-hidden="true">
                <path
                    d="M3 4h2l2.4 10.2A2 2 0 0 0 9.36 16h7.52a2 2 0 0 0 1.96-1.6L21 7H6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="9.5" cy="20" r="1.8" fill="currentColor" />
                <circle cx="17.5" cy="20" r="1.8" fill="currentColor" />
            </svg>

            {totalQty > 0 && <span className="cartIcon__badge">{totalQty}</span>}

            <div className="cartIcon__label">
                <div className="cartIcon__text">Мій кошик</div>
                <div className="cartIcon__sum">{totalSum.toLocaleString("uk-UA")} ₴</div>
            </div>
        </button>
    );
}
